module.exports = __webpack_public_path__ + "img/bread-sketch.bc49b215.png";